import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { addDays, format, startOfWeek, isSameDay, subWeeks, addWeeks,differenceInDays } from 'date-fns';
import { ko } from 'date-fns/locale'; // 한글 로케일 추가
import styles from './MainPage.module.css'; // CSS Module import

import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';




//// 이미지부분
import in_progress_icon from '../../assets/status/in_progress_icon.svg';
import completed_icon from '../../assets/status/completed_icon.svg';
import failed_icon from '../../assets/status/failed_icon.svg';
import x_icon from '../../assets/Button/x.svg';

import edit_icon from '../../assets/Button/dday_edit_icon.svg';
import edit_comment_icon from '../../assets/Button/edit_comment_icon.svg';

import calendar_icon from '../../assets/main/calendar-icon.svg';

import Previous from '../../assets/Button/Previous.svg';
import Next from '../../assets/Button/Next.svg';

////////// 이미지 부분 끝.

//// 상단바 내용
import Header from '../Header/Header';  // Header 컴포넌트 불러오기
////////// 상단바 내용 끝.

//// 하단바 내용
import Navbar from '../all_pages/Navbar'; // 네비게이션 불러오기

const apiUrl = process.env.REACT_APP_API_URL;  // 환경 변수로 API URL 불러오기


const MainPage = () => {
  const [currentDate, setCurrentDate] = useState(new Date()); // 현재 날짜
  const [selectedDate, setSelectedDate] = useState(new Date()); // 선택된 날짜
  const [isOrangeModalOpen, setIsOrangeModalOpen] = useState(false); // 주황색 섹션 모달 상태
  const [isGrayModalOpen, setIsGrayModalOpen] = useState(false);
  const navigate = useNavigate(); // 네비게이션

  const [error, setError] = useState(''); // 토큰 없으면 에러 내용 출력?

  //// 퀘스트 내용 수정 중
  const [quests, setQuests] = useState([]); // 퀘스트 저장 상태
  const [isModalOpen, setIsModalOpen] = useState(false); // 모달 상태
  const [activeQuest, setActiveQuest] = useState(null); // 선택된 퀘스트


  //// 퀘스트 완료 모달 내용 수정 중
  const [feedback, setFeedback] = useState('');  // 후기 입력 상태
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false); // 두 번째 모달 상태 (피드백 모달)
  ////////// 퀘스트 내용 수정 중 내용 끝.



  //// D-DAY 값 로드 및 저장
  const [ddayTitle, setDdayTitle] = useState(null);
  const [ddayDate, setDdayDate] = useState(null);
  const [questTitle, setQuestTitle] = useState(''); // 퀘스트 이름
  const [questDate, setQuestDate] = useState(''); // 퀘스트 종료일
  const [isButtonActive, setIsButtonActive] = useState(false); // 완료 버튼 활성화 여부
  ////////// D-DAY 값 로드 및 저장 끝.



  /// 달력
  // 달력 모달의 열림/닫힘 상태
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);


  //// 코멘트 기능
  const [comment, setComment] = useState(""); // 사용자 코멘트 상태
  const [isEditing, setIsEditing] = useState(false); // 편집 상태
  ////////// 코멘트 기능 끝.

  //// 헤더 내용 (오늘 날짜로 돌아가는 함수)
  const goToToday = () => {
    setCurrentDate(new Date()); // 오늘 날짜로 돌아가기
    setSelectedDate(new Date()); // 선택된 날짜도 오늘로 업데이트
    fetchQuestsForDate(new Date()); // 오늘의 퀘스트 다시 불러오기
  };

  // 현재 주의 시작 날짜
  const startDate = startOfWeek(currentDate, { weekStartsOn: 1 }); // 월요일 시작으로 설정

  // 주간 날짜 배열 생성
  const daysOfWeek = Array.from({ length: 7 }).map((_, index) =>
    addDays(startDate, index)
  );

  // 오늘 날짜
  const today = new Date();

  // 날짜 클릭 핸들러
  const handleDateClick = (date) => {
    setSelectedDate(date);
    fetchQuestsForDate(date);
    
    // 클릭한 날짜가 오늘이 아닌 경우 모달을 열지 않음
    if (!isSameDay(date, today)) {
      console.log("오늘이 아닌 날짜를 클릭했습니다. 모달을 열지 않습니다.");
      return;
  }
  };

  // 이전 주로 이동
  const handlePrevWeek = () => {
    setCurrentDate(subWeeks(currentDate, 1));
  };

  // 다음 주로 이동
  const handleNextWeek = () => {
    setCurrentDate(addWeeks(currentDate, 1));
  };

  // 모달 열기/닫기
  const handleOrangeModalOpen = () => setIsOrangeModalOpen(true);
  const handleOrangeModalClose = () => setIsOrangeModalOpen(false);

  const handleGrayModalOpen = () => setIsGrayModalOpen(true);
  const handleGrayModalClose = () => setIsGrayModalOpen(false);



  //// 퀘스트 관련 로직 

  // 현재 몇 일차인지 계산하는 함수
  const calculateQuestDay = (startDate) => {
    const today = new Date();
    const daysPassed = differenceInDays(today, new Date(startDate));
    return daysPassed + 1; // 시작일을 포함하여 1일차부터 시작
  };


  // 퀘스트 API 호출 함수
  const fetchQuestsForDate = async (date) => {
    const formattedDate = format(date, 'yyyy-MM-dd');
    const cachedQuests = localStorage.getItem(`quests_${formattedDate}`);
    const token = localStorage.getItem('accessToken');
    console.log("MainPage.js에서 읽은 토큰:", token);

    // 콘솔에 각 단계를 명확하게 출력하기 위한 로그 추가
    console.log('------ 시작: fetchQuestsForDate 함수 실행 ------');
    console.log(`선택된 날짜: ${formattedDate}`);
    console.log('토큰 확인:', token ? '토큰 있음' : '토큰 없음');

    // // 캐시된 데이터를 삭제하고 새로 불러오기
    // localStorage.removeItem(`quests_${formattedDate}`);

    if (!token) {
      console.error('토큰이 없습니다. API 요청을 수행할 수 없습니다.');
      return;
    }

    if (cachedQuests) {
        console.log('로컬 스토리지에서 퀘스트 데이터 찾음');
        console.log('로컬 스토리지 데이터:', JSON.parse(cachedQuests));
        setQuests(JSON.parse(cachedQuests));
    } else {
        try {
            console.log('로컬 스토리지에 데이터 없음. API 요청 시작');
            const response = await axios.get(`${apiUrl}/quest/checkthedate/?date=${formattedDate}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,  // JWT 토큰을 요청 헤더에 추가
                    'Content-Type': 'application/json'
                },
                withCredentials: true  // CORS 설정에서 중요한 부분
            });

            // API 응답이 성공적으로 완료되었을 때 로그 출력
            console.log('API 요청 성공:', response.data); // 성공한 경우 콘솔에 출력
            const fetchedQuests = response.data;
            if (fetchedQuests.length === 0) {
              // 값이 없을 경우 퀘스트 목록을 빈 배열로 설정
              console.log('퀘스트가 없습니다. 퀘스트 목록을 비웁니다.');
              setQuests([]);
          } else {
              setQuests(fetchedQuests);
              console.log('로컬 스토리지에 데이터 저장:', fetchedQuests);
              localStorage.setItem(`quests_${formattedDate}`, JSON.stringify(fetchedQuests));
          }
      } catch (error) {
          console.log('API 요청 실패');
          setQuests([]);  // API 요청 실패 시에도 목록을 빈 배열로 설정
          if (error.response) {
              console.error('서버 응답 에러:', error.response.data);
              console.error('응답 상태 코드:', error.response.status);
              console.error('응답 헤더:', error.response.headers);
          } else if (error.request) {
              console.error('요청이 전송되었으나 응답 없음:', error.request);
          } else {
              console.error('요청을 설정하는 중 에러 발생:', error.message);
          }
      }
  }

  console.log('------ 끝: fetchQuestsForDate 함수 실행 완료 ------');
};

const verifyAndRefreshToken = async () => {
  const accessToken = localStorage.getItem('accessToken');
  console.log("MainPage.js에서 읽은 토큰:", accessToken);
  const refreshToken = localStorage.getItem('refreshToken');

  if (!accessToken) {
    setError('로그인이 필요합니다.');
    localStorage.clear(); // 로컬스토리지 초기화
    window.location.href = '/login'; // 로그인 페이지로 이동
    // navigate('/login');
    return;
  }

  try {
    await axios.post(`${apiUrl}/token/verify/`, { token: accessToken });
  } catch (error) {
    if (error.response && error.response.status === 401 && refreshToken) {
      try {
        const refreshResponse = await axios.post(`${process.env.REACT_APP_API_URL}/token/refresh/`, { refresh: refreshToken });
        const newAccessToken = refreshResponse.data.access;
        localStorage.setItem('accessToken', newAccessToken);
      } catch (refreshError) {
        console.error('토큰 갱신 실패:', refreshError.response ? refreshError.response.data : refreshError.message);
      }
    } else {
      setError('토큰을 확인할 수 없습니다. 다시 로그인해주세요.');
    }
  }
};



  // 처음 로드될 때 오늘의 퀘스트 가져오기
  // useEffect(() => {
  //   fetchQuestsForDate(today);
  //   verifyAndRefreshToken();
  // }, []);

  useEffect(() => {
    const initialize = async () => {
      await verifyAndRefreshToken();
      fetchQuestsForDate(today); // 토큰 갱신 후 데이터 불러오기
    };
    initialize();
  }, []); 

  // 모달 핸들러 (퀘스트 클릭 시 열리게) 첫 번째 모달
  const handleQuestClick = (quest) => {
    if (quest.status === 'in_progress' && isSameDay(selectedDate, today)) {
      setActiveQuest(quest);
      setIsModalOpen(true);
    }
  };

  // 첫 번째 모달 닫기 및 두 번째 모달 열기
  const handleQuestComplete = () => {
    setIsModalOpen(false); // 첫 번째 모달 닫기
    setIsFeedbackModalOpen(true); // 두 번째 모달 열기
  };

  // 두 번째 모달에서 완료 버튼 클릭 시 처리 (퀘스트 완료 및 피드백 저장)
  const handleFeedbackSubmit = async (questLogId) => {
    if (!feedback) {
      // 피드백이 비어 있을 경우 경고 메시지 등을 추가할 수 있습니다.
      console.log('피드백이 비어있습니다.');
      return;
    }

    console.log('피드백 제출:', feedback);

    try {
      // 퀘스트 완료 및 피드백 저장 API 호출
      await completeQuestWithFeedback(questLogId, feedback);
      console.log(questLogId); // 로그로 확인

      // 성공 시 모달 닫기 및 UI 업데이트
      setIsFeedbackModalOpen(false);
      setFeedback(''); // 피드백 초기화
      console.log('퀘스트 완료 및 피드백 저장 완료');
    } catch (error) {
      // API 호출 실패 시 처리
      console.error('피드백 제출 실패:', error);
      // 추가적인 오류 처리 로직을 여기에 작성할 수 있습니다 (예: 오류 메시지 표시)
    }
  };


  // 첫 번째 모달 닫기
  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  // 두 번째 모달 닫기
  const handleFeedbackModalClose = () => {
    setIsFeedbackModalOpen(false);
  };


//// 퀘스트 완료 버튼 
// 퀘스트 완료 API 호출 함수
// 퀘스트 완료 및 후기 제출 API 호출 함수
const completeQuestWithFeedback = async (questId, feedback) => {  
  const token = localStorage.getItem('accessToken');

  try {
    const response = await axios.post(
      `${apiUrl}/quest/complete_quest/${questId}/`,  // API 경로에서 questId 사용
      { feedback },  // 후기 데이터 포함
      {
        headers: {
          Authorization: `Bearer ${token}`,  // JWT 토큰 인증
          'Content-Type': 'application/json',
        },
      }
    );
    
    // 퀘스트 완료 성공 시 로그 출력
    console.log('퀘스트 완료 및 후기 저장:', response.data);

    // 로컬 스토리지에서 캐시된 퀘스트 데이터를 삭제
    const formattedDate = format(new Date(), 'yyyy-MM-dd');
    localStorage.removeItem(`quests_${formattedDate}`);

    // 완료 후 새로운 데이터 fetch
    await fetchQuestsForDate(new Date());
    
  } catch (error) {
    // 오류 처리
    console.error('퀘스트 완료 실패:', error.response ? error.response.data : error.message);
  }
};




//// 후기 텍스트 입력 로직
// 텍스트 입력 시 feedback 상태 업데이트
const handleFeedbackChange = (event) => {
  setFeedback(event.target.value);
};
////////// 후기 텍스트 입력 로직 끝.

    //////////////////////////////////////////////////////////////////////////////////////// 퀘스트 관련 로직 끝



//// D-DAY 값 로드 및 저장 로직

  // D-DAY 값 로드 및 저장 로직
  useEffect(() => {
    const storedDdayTitle = localStorage.getItem('dday_title');
    const storedDdayDate = localStorage.getItem('dday_date');

      // 로컬스토리지에서 값을 불러올 때 로그 출력
    console.log('로컬스토리지에서 불러온 D-DAY 제목:', storedDdayTitle);
    console.log('로컬스토리지에서 불러온 D-DAY 날짜:', storedDdayDate);
    
    if (storedDdayTitle && storedDdayDate) {
      setDdayTitle(storedDdayTitle);
      setDdayDate(new Date(storedDdayDate));  // 날짜 객체로 변환
      console.log('로컬스토리지에 D-DAY 값이 있어 설정됨.');
    } else {
      console.log('로컬스토리지에 D-DAY 값이 없음. API 요청 시작.');
      fetchDdayFromDB();
    }
  }, []);

// // D-DAY 값 로드 및 저장 로직
// const fetchDdayFromDB = async (ddayTitle, ddayDate) => {
//   try {
//     const token = localStorage.getItem('accessToken');
//     if (!token) {
//       console.error('토큰이 없습니다.');
//       return;
//     }

//     // dday_date를 형식화할 때 시간을 제거하고 날짜만 보냄
//     const formattedDdayDate = `${ddayDate.getFullYear()}-${(ddayDate.getMonth() + 1).toString().padStart(2, '0')}-${ddayDate.getDate().toString().padStart(2, '0')}`;
    
//     // 요청 로그 추가
//     console.log('D-DAY 저장 요청:', {
//       dday_title: ddayTitle,
//       dday_date: formattedDdayDate
//     });
  
//     const response = await axios.post(`${apiUrl}/accounts/userdday/`, {
//           dday_title: ddayTitle,
//           dday_date: formattedDdayDate  // 시간 정보를 제거한 날짜만 전송
//       }, {
//           headers: {
//               Authorization: `Bearer ${token}`,
//               'Content-Type': 'application/json'
//           }
//       });

//     const { dday_title, dday_date } = response.data;
//     if (dday_title && dday_date) {
//       setDdayTitle(dday_title);
//       setDdayDate(new Date(dday_date));  // 서버에서 가져온 날짜를 Date 객체로 변환
//       localStorage.setItem('dday_title', dday_title);
//       localStorage.setItem('dday_date', dday_date);

//       // 저장된 D-DAY 데이터 로그 추가
//       console.log('D-DAY 저장 완료:', {
//         dday_title,
//         dday_date
//       });
//     } else {
//       console.log('API 응답에서 D-DAY 값이 없습니다.');
//       setDdayTitle(null);
//       setDdayDate(null);
//     }
//   } catch (error) {
//     console.error('D-DAY 정보를 가져오는데 실패했습니다.', error);
//   }
// };

// D-DAY 값 로드 및 저장 로직
const fetchDdayFromDB = async () => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      console.error('토큰이 없습니다.');
      return;
    }

    // D-DAY 조회 API 호출
    const response = await axios.get(`${apiUrl}/accounts/userdday/`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    // 응답 데이터 처리
    const { dday_title, dday_date } = response.data;
    if (dday_title && dday_date) {
      setDdayTitle(dday_title);
      setDdayDate(new Date(dday_date));  // 서버에서 가져온 날짜를 Date 객체로 변환
      localStorage.setItem('dday_title', dday_title);
      localStorage.setItem('dday_date', dday_date);

      // 저장된 D-DAY 데이터 로그 추가
      console.log('D-DAY 저장 완료:', { dday_title, dday_date });
    } else {
      console.log('D-DAY 데이터가 없습니다.');
      setDdayTitle(null);
      setDdayDate(null);
    }
  } catch (error) {
    console.error('D-DAY 정보를 가져오는데 실패했습니다.', error);
  }
};

  

  // 오늘 날짜와 D-DAY 날짜 차이를 계산하는 함수
  // 오늘 날짜와 D-DAY 날짜 차이를 계산하는 함수
  const calculateDaysLeft = (dday) => {
    const today = new Date();
    
    // 오늘 날짜와 D-DAY 날짜의 시간을 제거하고 날짜만 비교
    const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const startOfDday = new Date(dday.getFullYear(), dday.getMonth(), dday.getDate());
    
    // 날짜 차이를 계산하여 정확하게 일수를 계산
    const diffInDays = (startOfDday - startOfToday) / (1000 * 60 * 60 * 24); // 밀리초에서 일수로 변환
    return Math.round(diffInDays);
  };

  // 기존의 날짜 차이 계산 방식을 수정하여 시간을 무시하고 날짜만 비교하도록 변경하였습니다.
  

  // 완료 버튼 활성화 여부 체크
useEffect(() => {
  if (questTitle && questDate) {
    setIsButtonActive(true);
  } else {
    setIsButtonActive(false);
  }
}, [questTitle, questDate]);

// D-DAY 퀘스트 제목 변경 로직
const handleTitleChange = (e) => {
  setQuestTitle(e.target.value);  // 퀘스트 제목 상태 업데이트
  console.log('D-DAY 제목 변경:', e.target.value);  // 제목 변경 시 로그 출력
  const inputValue = e.target.value;
    // 글자 수가 9자를 초과하면 초과된 부분을 제거
    if (inputValue.length <= 9) {
      setQuestTitle(inputValue); // 글자 수가 9자 이하일 때만 상태 업데이트
  }
};

// 달력에서 날짜 변경 핸들러
const handleDateChange = (date) => {
  setDdayDate(date); // 선택된 날짜를 상태로 설정
  setIsCalendarOpen(false); // 날짜 선택 후 달력 닫기
  console.log('D-DAY 날짜 변경:', date);  // 날짜 변경 시 로그 출력
};

// // D-DAY 모달 로직
// const handleSave = () => {
//   if (isButtonActive) {
//     // 저장 로직 실행
//     console.log("퀘스트 저장:", questTitle, questDate);  // 퀘스트 제목과 날짜를 로그로 출력

//     // 날짜를 올바른 형식으로 변환하여 전송 (시간대 문제 해결)
//     const formattedQuestDate = new Date(questDate.getFullYear(), questDate.getMonth(), questDate.getDate());

//     fetchDdayFromDB(questTitle, formattedQuestDate); // 선택한 날짜를 저장

//     handleOrangeModalClose();
//   }
// };

// D-DAY 저장 로직
const handleSave = () => {
  if (isButtonActive) {
    console.log("퀘스트 저장:", questTitle, questDate);  // 퀘스트 제목과 날짜를 로그로 출력

    const formattedQuestDate = new Date(questDate.getFullYear(), questDate.getMonth(), questDate.getDate());

    // D-DAY API로 저장 요청
    saveDdayToDB(questTitle, formattedQuestDate);

    handleOrangeModalClose();  // 모달 닫기
  }
};

// D-DAY 저장을 위한 API 호출
const saveDdayToDB = async (ddayTitle, ddayDate) => {
  try {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      console.error('토큰이 없습니다.');
      return;
    }

    // 날짜 형식 변환
    const formattedDdayDate = `${ddayDate.getFullYear()}-${(ddayDate.getMonth() + 1).toString().padStart(2, '0')}-${ddayDate.getDate().toString().padStart(2, '0')}`;

    // D-DAY 저장 API 호출
    const response = await axios.post(`${apiUrl}/accounts/userdday/`, {
      dday_title: ddayTitle,
      dday_date: formattedDdayDate
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    // 응답 데이터 처리
    const { dday_title, dday_date } = response.data;
    setDdayTitle(dday_title);
    setDdayDate(new Date(dday_date));
    localStorage.setItem('dday_title', dday_title);
    localStorage.setItem('dday_date', dday_date);

    console.log('D-DAY 저장 성공:', { dday_title, dday_date });
    // fetchDdayFromDB 호출로 최신 데이터 반영
    await fetchDdayFromDB(); // 저장 후 데이터 로드 및 상태 업데이트
  } catch (error) {
    console.error('D-DAY 저장에 실패했습니다.', error);
  }
};

// 달력 토글
const toggleCalendar = () => {
  setIsCalendarOpen((prev) => !prev); // 달력을 열고 닫기
};

//////////////////////////////////////////////////////////////////////////////////////// D-DAY 값 로드 및 저장 로직 끝



//// 코멘트 기능
 // 1. 로컬 스토리지에서 코멘트 확인
 useEffect(() => {
  const storedComment = localStorage.getItem('userComment');
  if (storedComment) {
    setComment(storedComment); // 로컬 스토리지에 값이 있으면 사용
  } else {
    fetchCommentFromDB();
  }
}, []);

const fetchCommentFromDB = async () => {
  try {
    const response = await axios.get(`${apiUrl}/accounts/user_comment`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // JWT 토큰 사용
      },
    });
    const { comment_text } = response.data;
    if (comment_text) {
      setComment(comment_text);
      localStorage.setItem('userComment', comment_text); // 값이 있으면 로컬 스토리지에 저장
    } else {
      setComment("오늘 할 일을\n내일로 미루지 말자"); // 기본값 설정
    }
  } catch (error) {
    console.error('DB에서 코멘트를 불러오는 중 오류 발생', error);
    setComment("오늘 할 일을\n내일로 미루지 말자"); // 오류 발생 시 기본값 설정
  }
};

// 사용자가 입력한 코멘트에서 엔터(\n)를 <br />로 변환하여 출력하는 함수
const formatComment = (comment) => {
  return comment.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ));
};

// 코멘트 입력 핸들러
// const handleCommentChange = (e) => {
//   const inputValue = e.target.value;
//   const lineBreaks = (inputValue.match(/\n/g) || []).length; // 줄바꿈 개수 확인

//   if (lineBreaks < 3) {  // 줄바꿈이 3개 미만일 때만 입력 허용
//     setComment(inputValue);
//   } else {
//     // 3줄을 넘으면 새로운 줄바꿈 입력을 막음
//     setComment(inputValue.slice(0, inputValue.length - 1));  // 마지막 문자를 제거하여 입력 방지
//   }
// };

// 코멘트 입력 핸들러
const handleCommentKeyDown = (e) => {
  const inputValue = e.target.value;
  const lineBreaks = (inputValue.match(/\n/g) || []).length;

  // console.log("Key pressed:", e.key); // 눌린 키 확인
  // console.log("Current line breaks:", lineBreaks);

  if (e.key === "Enter" && lineBreaks >= 3) {
    e.preventDefault(); // 엔터 입력 차단
    // console.log("Enter key blocked due to line break limit");
  }

  if (inputValue.length >= 20 && e.key !== "Backspace" && e.key !== "Delete") {
    e.preventDefault(); // 초과 입력 차단
    // console.log("Input length exceeded limit");
  }
};

const handleCommentChange = (e) => {
  const inputValue = e.target.value;
  // console.log("Input value:", inputValue); // 실시간으로 입력값 확인
  // console.log("Input length:", inputValue.length); // 입력값 길이 확인

  const lineBreaks = (inputValue.match(/\n/g) || []).length;
  // console.log("Line breaks:", lineBreaks); // 줄바꿈 개수 확인

  // 조건 확인 및 상태 업데이트
  if (inputValue.length > 20 || lineBreaks >= 3) {
    const trimmedValue = inputValue
      .slice(0, 20) // 최대 길이 제한
      .split('\n')
      .slice(0, 3) // 줄바꿈 제한
      .join('\n');
    setComment(trimmedValue);
  } else {
    setComment(inputValue);
  }
};

// 완료 버튼 클릭 시 처리 함수
const handleSaveComment = () => {
  if (comment) {
    console.log("저장할 코멘트", comment);
    // 서버로 데이터 전송 (DB 저장 로직 추가)
    axios.post(`${apiUrl}/accounts/user_comment/`, { comment }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // JWT 토큰 사용
      },
    })
      .then(response => {
        console.log('코멘트 저장 성공:', response.data);
        // 저장 후 로컬 스토리지에도 업데이트
        localStorage.setItem('userComment', comment); 
        // 저장 후 DB에서 코멘트 다시 불러오기 (데이터 동기화)
        fetchCommentFromDB();
        // 사용자에게 성공 피드백 (선택적으로 알림이나 메시지 표시)
        alert("코멘트가 성공적으로 저장되었습니다.");
        // 저장 후 모달 닫기
        handleGrayModalClose();  // 모달 닫기 함수 호출
        // 페이지 새로고침
        window.location.reload();  // 페이지 새로고침
      })
      .catch(error => {
        console.error('코멘트 저장 실패:', error);
        alert("코멘트 저장 중 오류가 발생했습니다.");
      });
  }
};
//////////////////////////////////////////////////////////////////////////////////////// 코멘트 기능 끝.


  return (
    <div className={styles.container}>
      {/* 달력 페이지 내용 */}
        <Header title="Dashboard" showCalendarIcon={true} showProfileIcon={true} goToToday={goToToday} />
      {/* 주간 캘린더 */}
      <div className={styles.calendarContainer}>
      <div className={styles.header}>
        <button className={styles.navButton} onClick={handlePrevWeek}>
          <img src={Next} alt="이전" className={styles.arrowImage} />
        </button>
        <h2 className={styles.calendardate}>{format(currentDate, 'yyyy년 MM월')}</h2>
        <button className={styles.navButton} onClick={handleNextWeek}>
          <img src={Previous} alt="다음" className={styles.arrowImage} />
        </button>
      </div>


        <div className={styles.week}>
          {daysOfWeek.map((day) => (
            <div key={day} className={styles.dayContainer}>
              {/* 요일을 한글로 출력 */}
              <span className={styles.dayName}>{format(day, 'E', { locale: ko })}</span>
              {/* 일자 */}
              <button
                className={`${styles.dayButton} ${
                  isSameDay(day, selectedDate) ? styles.activeDay : ''
                }`}
                onClick={() => handleDateClick(day)}
              >
                <span className={styles.daydate}>{format(day, 'd')}</span>
              </button>
            </div>
          ))}
        </div>

        {/* <div className={styles.selectedDate}>
          <h3>{format(selectedDate, 'yyyy년 MM월 d일')}</h3>
          <p>선택한 날짜의 일정 내용이 여기에 표시됩니다.</p>
        </div> */}
      </div>

        {/* 주황색 섹션 */}
        <div className={styles.sectionContainer}>
          <div className={`${styles.orangeSection} ${ddayTitle && ddayDate ? styles.withContent : ''}`} onClick={handleOrangeModalOpen}>
            {ddayTitle && ddayDate ? (
              <>
                <h2 className={styles.ddayTitle}>
                  {ddayTitle.length > 9 ? `${ddayTitle.substring(0, 9)}...` : ddayTitle}
                  <br />
                  퀘스트 종료까지
                </h2>
                <p className={styles.ddayCount}>D-{calculateDaysLeft(ddayDate)}일</p>
                <img className={styles.editicon} src={edit_icon} alt="Edit icon" />
              </>
            ) : (
              <>
                <p className={styles.ddayMessage}>D-DAY를<br /> 설정하세요!</p>
                <img className={styles.editicon} src={edit_icon} alt="Edit icon" />
              </>
            )}
          </div>

        {/* 회색 섹션 */}
        <div className={styles.graySection} onClick={handleGrayModalOpen}>
          <p className={styles.commentText}>
            {comment.split("\n").map((line, index) => (
              <span key={index}>
                {line}
                <br />
              </span>
            ))}
          </p>
          <img className={styles.editicon} src={edit_comment_icon} alt="Edit icon" />
        </div>
      </div>

      {/* 주황색 섹션 모달 */}
      {isOrangeModalOpen && (
        <div className={styles.modal}>
          <div className={styles.modalOverlay} onClick={handleOrangeModalClose}></div>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <h2 className={styles.modalTitle}>퀘스트 설정</h2>
              <button className={styles.closeButton} onClick={handleOrangeModalClose}>
                <img src={x_icon} alt="닫기" className={styles.closeIcon} /> {/* 이미지를 별도의 클래스에 적용 */}
              </button>
            </div>
            <p className={styles.modalTitle_text} >퀘스트 이름</p>

            <div className={styles.modalBody}>
              {/* <label className={styles.label}>퀘스트 이름</label> */}
              <div className={styles.inputContainer}>
                <input 
                  type="text" 
                  className={styles.inputField} 
                  value={questTitle} 
                  onChange={handleTitleChange}
                  maxLength="9" // 글자 수 제한
                  onFocus={() => questTitle === "D-DAY 퀘스트를 작성해주세요!" && setQuestTitle("")} 
                  onBlur={() => questTitle === "" && setQuestTitle("D-DAY 퀘스트를 작성해주세요!")} 
                />
                <button className={styles.clearButton} onClick={() => setQuestTitle('')}>
                  <img src={x_icon} alt="닫기" className={styles.clearIcon} />
                </button>

              </div>

              <label className={styles.modalTitle_text}>퀘스트 종료 예정일</label>
              <div className={styles.datePickerContainer}>
                <p className={styles.dateText}>
                  {questDate ? format(questDate, 'yyyy년 MM월 dd일') : "날짜를 선택해주세요!"}
                </p>
                <button className={styles.datePickerButton} onClick={toggleCalendar}>
                  <img src={calendar_icon} alt="달력 아이콘" className={styles.dateIcon} />
                </button>
              </div>
              {/* 캘린더 모달 */}
              {isCalendarOpen && (
                <div className={styles.calendarModal}>
                  <Calendar
                    className="react-calendar"
                    onChange={(date) => {
                      setQuestDate(date); // 선택된 날짜 저장
                      toggleCalendar(); // 캘린더 닫기
                    }}
                    value={questDate} // 선택된 날짜
                    formatDay={(locale, date) => format(date, 'd')} // 날짜 형식
                    locale="ko-KR" // 한국어 달력
                  />
                </div>
              )}




              <div className={styles.modalFooter}>
                <button 
                  className={styles.completeButton} 
                  onClick={handleSave} 
                  disabled={!questTitle || !questDate} // 퀘스트 이름과 날짜가 모두 설정되지 않으면 비활성화
                >
                  완료
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* 회색 섹션 모달 */}
      {isGrayModalOpen && (
        <div className={styles.modal}>
          <div className={styles.modalOverlay} onClick={handleGrayModalClose}></div>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <h2 className={styles.modalTitle}>코멘트 설정</h2>
              <button className={styles.closeButton} onClick={handleGrayModalClose}>
                <img src={x_icon} alt="닫기" className={styles.closeIcon} /> {/* X 아이콘 */}
              </button>
            </div>

            <div className={styles.modalBody}>
              <label className={styles.label}>코멘트 입력</label>
              <div className={styles.inputContainer}>
              <textarea
                value={comment}
                onChange={handleCommentChange} // 실시간 입력값 제어
                onKeyDown={handleCommentKeyDown} // 키 입력 제어
                placeholder={!isEditing && !comment ? '설정하고 싶은 코멘트를 작성하세요!' : ''}
                className={styles.textarea}
                onFocus={() => setIsEditing(true)}
                onBlur={() => setIsEditing(comment !== '')}
              />

                <button className={styles.clearButton} onClick={() => setComment('')}>
                  <img src={x_icon} alt="clear icon" />
                </button>
              </div>
              <div className={styles.modalFooter}>
                <button 
                  className={styles.completeButton} 
                  onClick={handleSaveComment} 
                  disabled={!comment.trim()} // 입력된 내용이 없으면 비활성화
                >
                  완료
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      {/* 퀘스트 목록 */}
      <div className={styles.questList}>
      {/* 퀘스트 목록 제목 */}
      <p className={styles.questListtext}>
        {format(selectedDate, 'MM월 dd일')} 할 일 <span className={styles.questListtextnumber}>{quests.length}</span>
      </p>
          {/* <h2>{format(currentDate, 'yyyy년 MM월 DD일')}</h2> */}
          {quests.length === 0 ? (
              <p className={styles.questListtextp}>오늘 할 일이 없습니다.</p>
          ) : (
              quests.map((quest, index) => (
                  <div
                      key={quest.id}  // quest.id를 key로 사용
                      className={styles.questItem}
                      onClick={() => handleQuestClick(quest)}
                  >
                      <div className={styles.textContainer}>
                          {/* 퀘스트 대 타이틀 */}
                          <span className={styles.questMainTitle}>{quest.quest_title || '대 타이틀 없음'}</span>

                          {/* 세부 타이틀 */}
                          <span className={styles.questSubTitle}>{quest.title || '세부 타이틀 없음'}</span>
                      </div>

                      {/* 상태 아이콘 */}
                      <div className={styles.iconContainer}>
                          {quest.status === 'completed' && <img src={completed_icon} alt="완료 아이콘" className={styles.icon} />}
                          {quest.status === 'give_up' && <img src={failed_icon} alt="포기 아이콘" className={styles.icon} />}
                          {quest.status === 'in_progress' && <img src={in_progress_icon} alt="진행 중 아이콘" className={styles.icon} />}
                          {quest.status === 'failed' && <img src={failed_icon} alt="실패 아이콘" className={styles.icon} />}
                      </div>
                  </div>
              ))
          )}
      </div>



      {/* 첫 번째 퀘스트 모달 */} 
      {isModalOpen && activeQuest && (
        <div className={styles.modal}> {/* 첫 번째 모달 스타일 */}
          <div className={styles.modalOverlay} onClick={handleModalClose}></div>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <p className={styles.modalHeader_Result_title}>{activeQuest.quest_title || '대 타이틀 없음'}</p>
              {/* <h2 className={styles.modalTitle}>{activeQuest.quest_title}</h2> */}
              <button className={styles.closeButton} onClick={handleModalClose}>
                <img src={x_icon} alt="닫기" />
              </button>
            </div>

            <p className={styles.modalHeader_Result} >{activeQuest.title}</p>
            <p className={styles.modalHeader_Resultp}>{activeQuest.description}</p>
            {/* <p className={styles.modalHeader_Result}>퀘스트는 어땠는지 작성해 주세요!</p>
            
            <div className={styles.Result_modal_first}>
              <p>완료 퀘스트</p>
              <h2>{activeQuest.title}</h2>
              <p>{activeQuest.description}</p>
            
            </div> */}
            
            
            <button className={styles.modalButton} onClick={() => handleQuestComplete(activeQuest.id)}>
              퀘스트 완료
            </button>
          </div>
        </div>
      )}

  {/* 두 번째 모달 (퀘스트 완료 후 피드백) */}
  {isFeedbackModalOpen && activeQuest && (
    <div className={styles.modal}> {/* 두 번째 모달에 다른 스타일 적용 */}
      <div className={styles.modalOverlay} onClick={handleFeedbackModalClose}></div>
      <div className={styles.feedbackModalContent}> {/* 새로운 스타일 클래스 */}
        <div className={styles.modalHeader}>
          <p className={styles.modalTitle_Second}>퀘스트를 완료하셨군요!</p>
          <button className={styles.closeButton} onClick={handleFeedbackModalClose}>
            <img src={x_icon} alt="닫기" />
          </button>
        </div>
        <p className={styles.modalTitle_Second_text}>퀘스트는 어땠는지 알려주세요!</p>
        <p className={styles.modalTitle_Second_text}>완료 퀘스트</p>
        <p className={styles.modalTitle_Second_text} >{activeQuest.title}</p>
        <textarea 
          className={styles.feedbackInput} 
          placeholder="후기를 작성해주세요!" 
          value={feedback} 
          onChange={handleFeedbackChange}  // 피드백 변경 이벤트 처리
        />
        {/* feedback 상태에 따라 버튼 활성화/비활성화 */}
        <button 
          className={styles.modalButton} 
          onClick={() => handleFeedbackSubmit(activeQuest.id)} 
          disabled={!feedback}  // feedback이 없을 때는 버튼 비활성화
        >
          완료
        </button>
      </div>
    </div>
  )}

  
  {/* <Navbar /> */}









    </div>
  );
};

export default MainPage;
